export default __webpack_public_path__ + "static/media/profile.7570c0df.jpg";